<se-fe-page
  seFeDataWidth="full"
  seFeDataBackLink="/user/household"
  [seFeDataBackQueryParams]="backParams"
  seFeDataBackText="Household">
  @if (loaded) {
    <se-fe-header seFePageHeader [seFeDataTitle]="displayName" size="750"></se-fe-header>
  }
  @if (siteMemberships.length) {
    <div seFePageContent class="center-cards" style="display: flex; flex-wrap: wrap;">
      @for (membership of siteMemberships; track membership) {
        <div>
          <se-po-organization-card
            [siteMembership]="membership" (orgRemoved)="handleRemove($event)">
          </se-po-organization-card>
        </div>
      }
    </div>
  }
  @if (!siteMemberships.length) {
    <se-fe-empty-state seFePageContent seFeDataTitle="No Organizations Found">
      <se-fe-icon seFeEmptyStateIcon seFeDataName="spot_whistle" seFeDataSize="950"></se-fe-icon>
    </se-fe-empty-state>
  }
</se-fe-page>
